import jwtAxios from 'main/services/auth/jwt-auth';
import {isEmpty, notEmpty} from 'main/utility/CommonUtil';
import {
  GET_APP_ENDPOINT,
  GET_LAYOUT_SPEC,
  GET_MENU_SPEC,
  GET_QUICK_LINKS,
  HIDE_ALERT,
  SHOW_ERROR,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
} from 'shared/constants/ActionTypes';

/**
 * Global Utility to handle API lifecycles
 * For non-widget specific API calls.
 * Handles: Loading Start -> API Call -> Success/Error Dispatch -> Loading End
 */
export const handleApiCall = async (dispatch, apiCall, successAction) => {
  try {
    const response = await apiCall();
    const hasSuccess = isSuccessResponse(response);
    const message = response.data?.message;

    if (hasSuccess) {
      notEmpty(message) && dispatch(showMessage(message));

      const dataBody = response.data?.body;
      if (typeof successAction === 'function') {
        successAction(dataBody);
      } else if (successAction) {
        dispatch({type: successAction, payload: dataBody});
      }
    } else {
      // Handles cases where API returns success: false
      notEmpty(message) && dispatch(showError(message));
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.message || 'Error: Something went wrong';
    dispatch(showError(errorMsg));
  }
};

export const showError = (error) => ({
  type: SHOW_ERROR,
  payload: error,
});

export const showMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message,
});

export const hideAlert = () => {
  return {type: HIDE_ALERT};
};

export const onToggleAppDrawer = () => {
  return {type: TOGGLE_APP_DRAWER};
};

export const isSuccessResponse = (response) => {
  return notEmpty(response) && response.data.success;
};

export function toFormDataParam(jsonPayload) {
  const formData = new FormData();
  const fileFields = jsonPayload.fileInputFields;
  Object.entries(jsonPayload).forEach(([key, value]) => {
    if (!isEmpty(fileFields) && fileFields.includes(key)) {
      value.forEach((file) => {
        if (file.type === 'file') formData.append(key, file.src);
      });
    } else if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  return formData;
}

export const onGetMenuSpec = () => (dispatch) => {
  handleApiCall(dispatch, () => jwtAxios.get('/l/spec/menu'), GET_MENU_SPEC);
};

export const onGetAppEndpoint = () => (dispatch) => {
  handleApiCall(dispatch, () => jwtAxios.get('/dp/'), GET_APP_ENDPOINT);
};
export const onGetQuickLinks = () => (dispatch) => {
  handleApiCall(
    dispatch,
    () => jwtAxios.get('/l/spec/quickLinks'),
    GET_QUICK_LINKS,
  );
};

export const onGetLayoutSpec = (layoutId) => (dispatch) => {
  handleApiCall(
    dispatch,
    () => jwtAxios.get(`/l/spec/${layoutId}`),
    (data) =>
      dispatch({
        type: GET_LAYOUT_SPEC,
        payload: data,
        layoutId: layoutId,
      }),
  );
};
